module.exports = __webpack_public_path__ + "img/cru.e61a0d8.svg";